import React, { forwardRef } from 'react';
import { cx } from '../utils';
import './SegmentedControl.css';

// options: [{ value, label, disabled? }]; value — tanlangan qiymat.
// onChange(value) har bosilganda chaqiriladi (faol variant qayta bosilsa ham) —
// mavjud onClick={() => setX(value)} mantiqi bilan bir xil ishlashi uchun.
// size: sm | md
const SegmentedControl = forwardRef(function SegmentedControl(
  { options = [], value, onChange, size = 'md', fullWidth = false, className, ...rest },
  ref
) {
  return (
    <div
      role="group"
      {...rest}
      ref={ref}
      className={cx('ui-segmented', `ui-segmented--${size}`, fullWidth && 'ui-segmented--full', className)}
    >
      {options.map((option) => {
        const active = option.value === value;
        return (
          <button
            key={String(option.value)}
            type="button"
            className={cx('ui-segmented__item', active && 'ui-segmented__item--active')}
            aria-pressed={active}
            disabled={option.disabled}
            onClick={() => onChange && onChange(option.value)}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
});

export default SegmentedControl;
